export type MenuPanelComponentProps = {
    /** Příznak, zda se má menu panel vykreslit v širší variantě */
    wider?: boolean;
};
